import type { SavedContentMutationParams } from '../types';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@workramp/ui';
import { useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { I18n } from '~/common/explicit-exports';
import { savedContentKeys } from '../utils';

export function removeSavedContent({ id, type }: SavedContentMutationParams): Promise<boolean> {
  return FetchPromise.delete('bookmark', { content_id: id, content_type: type });
}

export function useRemoveSavedContentMutation() {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useDefaultMutation(removeSavedContent, {
    onSuccess: async () => {
      toast.open({ children: I18n.t('js.learner.saved_content.removed_from_saved_content') });
      await queryClient.invalidateQueries(savedContentKeys.content());
    },
  });
}
